import { AppFeature } from '@ivy-monorepo/shared'
import { usePermissions } from '../../contexts/PermissionsContext'
import EventbriteEventsTab from './EventbriteEventsTab'

/** Admin > Eventbrite: Ivy's Eventbrite events, with import into venues and removal from Ivy. */
const EventbritePage = () => {
  const { features, isLoading } = usePermissions()

  return (
    <div className="users-container">
      <div className="users-header">
        <h2 className="eventbrite-page__title">
          <img src="/images/eventbrite.png" alt="" />
          Eventbrite
        </h2>
      </div>
      {isLoading ? null : features[AppFeature.Eventbrite] ? (
        <EventbriteEventsTab />
      ) : (
        <p className="eventbrite-events-tab__note">Eventbrite is off. Turn on Eventbrite in Feature flags to import events.</p>
      )}
    </div>
  )
}

export default EventbritePage
